<template>
    <div>
        <loading
            :active.sync="loading.app"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link :to="{ name: 'account' }" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Pengaturan Struk</div>
        </div>
        <!-- * App Header -->
        <!-- App Capsule -->
        <div id="appCapsule" v-if="loading.app == false">
            <div class="section inset mt-2">
                <div class="pl-1 pr-1">
                    <h4 class="mb-0" style="font-weight: bold">Header Struk</h4>
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label">Nama Usaha</label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="data_struk.business_name"
                                style="font-size: 13px"
                            />
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                    </div>
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label">Alamat Usaha</label>
                            <textarea
                                class="form-control"
                                v-model="data_struk.business_address"
                                style="font-size: 13px"
                            ></textarea>
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                    </div>
                    <h4 class="mt-2 mb-0" style="font-weight: bold">
                        Footer Struk
                    </h4>
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label">Deskripsi Usaha</label>
                            <textarea
                                class="form-control"
                                v-model="data_struk.business_description"
                                style="font-size: 13px"
                                rows="3"
                            ></textarea>
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                    </div>
                    <div class="form-group basic">
                        <button
                            class="btn btn-primary btn-block btn-lg"
                            @click="showDialog('show')"
                        >
                            Simpan
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <Dialog
            ref="dialog"
            :loading="dialogLoading"
            :title="'Simpan'"
            @confirm="submit()"
        >
            <p>Anda yakin akan merubah pengaturan struk?</p>
        </Dialog>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import $axios from '../../api.js';
    export default {
        data() {
            return {
                dialogLoading: false,
                data_struk: {
                    business_name: '',
                    business_address: '-',
                    business_description:
                        'Tersedia Pulsa, Paket Data Semua Operator, Token PLN, Bayar Tagihan Listrik, PDAM, Telkom dan Pembayaran Lainnya',
                },
            };
        },
        created() {
            this.$store.commit('SET_LOADING', { app: true });
            this.getStruk();
        },
        computed: {
            ...mapState(['customer', 'loading', 'toast', 'VUE_ENV']),
        },
        methods: {
            showDialog(value) {
                let element = this.$refs.dialog.$el;
                window.$(element).modal(value);
            },
            getStruk() {
                $axios
                    .get('/struk')
                    .then(response => {
                        if (response.data.data != null) {
                            this.data_struk = response.data.data;
                        } else {
                            this.data_struk.business_name =
                                this.VUE_ENV.VUE_APP_NAME;
                        }
                        this.$store.commit('SET_LOADING', { app: false });
                    })
                    .catch(error => {
                        this.$store.commit('SET_LOADING', { app: false });
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: error.response.data.message,
                            tipe: 'danger',
                        });
                    });
            },
            submit() {
                this.dialogLoading = true;
                $axios
                    .post('/struk/update', this.data_struk)
                    .then(response => {
                        this.showDialog('hide');
                        this.dialogLoading = false;
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: response.data.message,
                            tipe: 'default',
                            icon: 'success',
                        });
                    })
                    .catch(error => {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: error.response.data.message,
                            tipe: 'default',
                            icon: 'danger',
                        });
                        this.showDialog('hide');
                        this.dialogLoading = false;
                    });
            },
        },
        destroyed() {
            this.$store.commit('RESET_LOADING');
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
